import { graphql } from 'react-relay';

export const businessStatusQuery = graphql`
  query businessInitQuery($refundHistoryId: String!, $bmanTin: String) {
    getSurveyBusinessAnswer(refundHistoryId: $refundHistoryId, bmanTin: $bmanTin) {
      result
      businessAnswer {
        tnm
        bsno
        bmanTin
        isCompleted
      }
    }
  }
`;

export const introQuery = graphql`
  query businessIntroQuery($refundHistoryId: String!, $bmanTin: String) {
    getSurveyBusinessInfo(refundHistoryId: $refundHistoryId, bmanTin: $bmanTin) {
      result
      business {
        ofbDt
        bsno
        tnm
      }
    }
  }
`;

export const startBusinessQuery = graphql`
  query businessStartQuestionQuery($refundHistoryId: String!, $bmanTin: String) {
    getSurveyBusinessAnswer(refundHistoryId: $refundHistoryId, bmanTin: $bmanTin) {
      result
      businessAnswer {
        isStartBusinessDirectly
      }
    }
  }
`;

export const sameIndustryQuery = graphql`
  query businessSameIndustryQuery($refundHistoryId: String!, $bmanTin: String) {
    getSurveyBusinessAnswer(refundHistoryId: $refundHistoryId, bmanTin: $bmanTin) {
      result
      businessAnswer {
        hasPreviousBusinessInSameIndustry
      }
    }
  }
`;

export const smallBossMachineOwnerQuery = graphql`
  query businessSmallBossMachineOwnerQuery($refundHistoryId: String!, $bmanTin: String) {
    getSurveyBusinessAnswer(refundHistoryId: $refundHistoryId, bmanTin: $bmanTin) {
      result
      businessAnswer {
        isSmallBossOrMachineOwner
      }
    }
  }
`;

export const signboardQuery = graphql`
  query businessSignboardQuery($refundHistoryId: String!, $bmanTin: String) {
    getSurveyBusinessInfo(refundHistoryId: $refundHistoryId, bmanTin: $bmanTin) {
      business {
        ofbDt
      }
    }
    getSurveyBusinessAnswer(refundHistoryId: $refundHistoryId, bmanTin: $bmanTin) {
      result
      businessAnswer {
        isNewSignboard
      }
    }
  }
`;

export const partnerQuery = graphql`
  query businessPartnerQuery($refundHistoryId: String!, $bmanTin: String) {
    getSurveyBusinessInfo(refundHistoryId: $refundHistoryId, bmanTin: $bmanTin) {
      business {
        ofbDt
      }
    }
    getSurveyBusinessAnswer(refundHistoryId: $refundHistoryId, bmanTin: $bmanTin) {
      result
      businessAnswer {
        hasPartnerAtTheTimeOfEstablishment
      }
    }
  }
`;

export const takeoverEmployeeQuery = graphql`
  query businessTakeoverEmployeeQuery($refundHistoryId: String!, $bmanTin: String) {
    getSurveyBusinessAnswer(refundHistoryId: $refundHistoryId, bmanTin: $bmanTin) {
      result
      businessAnswer {
        hasTakingOverEmployees
        takingOverEmployees {
          indvTin
          ieNm
          birthday
          attrYears
        }
      }
    }
  }
`;

export const workLocationCheckQuery = graphql`
  query businessWorkLocationCheckQuery($refundHistoryId: String!, $bmanTin: String) {
    getSurveyBusinessAnswer(refundHistoryId: $refundHistoryId, bmanTin: $bmanTin) {
      result
      businessAnswer {
        isWorkingAtRegisteredAddress
      }
    }
  }
`;

export const officeTypeQuery = graphql`
  query businessPlaceTypeQuery($refundHistoryId: String!, $bmanTin: String) {
    getSurveyBusinessAnswer(refundHistoryId: $refundHistoryId, bmanTin: $bmanTin) {
      result
      businessAnswer {
        businessPlaceType
        businessPlaceTypeComment
      }
    }
  }
`;

export const locationQuery = graphql`
  query businessLocationQuery($refundHistoryId: String!, $bmanTin: String) {
    getSurveyBusinessInfo(bmanTin: $bmanTin, refundHistoryId: $refundHistoryId) {
      business {
        adr
        ofbDt
      }
    }
    getSurveyBusinessAnswer(bmanTin: $bmanTin, refundHistoryId: $refundHistoryId) {
      result
      businessAnswer {
        isStartBusinessDirectly
        isFirstLocation
        locations {
          year
          address
          isFirstLocation
          isUnknownRelocationYear
        }
      }
    }
  }
`;
